/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

const toMultipartFormData = (data = {}) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    // Only send file-like payloads for image fields; skip existing URL strings.
    if (key === "image" && !(value instanceof Blob)) {
      return;
    }

    formData.append(key, value);
  });

  return formData;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getPassengersList: (params) => {
    return axios.get(API_ENDPOINTS.GET_CUSTOMERS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" ,"x-tenant-slug":"default"},
      params,
    });
  },
  getPassengerDetails: (id, params = { userType: "USER" }) => {
    return axios.get(API_ENDPOINTS.GET_CUSTOMER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getDocumentsTypes: (userType = "USER") => {
    return axios.get(API_ENDPOINTS.USER_DOCUMENTS_TYPE, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params: { userType },
    });
  },
  getPassengerDocumentsByPassengerId: (id, params = { userType: "USER" }) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_DOCUMENTS_BY_PASSENGER_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  updatePassengerDocument: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PASSENGER_DOCUMENT_END_POINT, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
        "x-tenant-slug": "default",
      },
    });
  },
  deletePassengerDocument: (data) => {
    return axios.request({
      method: "delete",
      url: API_ENDPOINTS.DELETE_USER_DOCUMENT_END_POINT,
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      data,
    });
  },
  addPassengers: (data) => {
    const nextData = data instanceof FormData ? data : { userType: "USER", ...(data || {}) };
    const formData = nextData instanceof FormData ? nextData : toMultipartFormData(nextData);
    return axios.post(API_ENDPOINTS.ADD_PASSENGERS, formData, {
      headers: { isAuthRequired: true, "x-tenant-slug":"default" },
    });
  },
  updatePassengers: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_CUSTOMER_DETAILS_BY_ID + "/" + id;
    const nextData = data instanceof FormData ? data : { userType: "USER", ...(data || {}) };
    const formData = nextData instanceof FormData ? nextData : toMultipartFormData(nextData);
    return axios.put(url, formData, {
      headers: { isAuthRequired: true, "x-tenant-slug":"default" },
    });
  },
  deletePassenger: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_CUSTOMER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  deletedriver: (data) => {
  return axios.delete(API_ENDPOINTS.DELETE_DRIVER, {
    headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    data
  });
  },
  getPassengerrequesthistory: (params) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_REQUEST_HISTORY + "/" + params.passenger_id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params
    });
  },
  getPassengerrequesthistorybyid: (id) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_REQUEST_HISTORY_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" }
    });
  },
  getPassengertriphistorybyid: (id) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_TRIP_HISTORY_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" ,"x-tenant-slug":"default"}
    });
  },
  deletePassengerrequesthistorybyid: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_PASSENGER_REQUEST_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" }
    });
  },
};
